import en from './en.js';
import nl from './nl.js';

export default {
    en, nl
};
